<template>
    <v-navigation-drawer app light :width="250" v-model="drawer">
        <v-toolbar flat color="white">
            <v-list>
                <img src="../../assets/vfalogo_thumb.png" alt="">
            </v-list>
        </v-toolbar>

        <v-divider></v-divider>

        <v-list dense class="pt-0">
            <v-list-tile class="tile"
                         v-for="item in items"
                         :key="item.title"
                         router :to="item.link"
                         active-class="white--text"
            >
                <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        data() {
            return {
                drawer: false,
                items: [
                    {title: 'Home', icon: 'home', link: '/'},
                    // {title: 'Upload', icon: 'publish', link: '/upload'},
                    {title: 'Samples', icon: 'publish', link: '/samples'},
                    // {title: 'Intruction', icon: 'info', link: '/instruction'},
                    {title: 'Contact', icon: 'email', link: '/contact'},
                ],
                right: null
            }
        },
        mounted() {
            let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            this.drawer = w >= 850;
        }
    }
</script>

<style>
    .theme--light.v-navigation-drawer {
        box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1705);
    }

    .tile {
        margin: 3px 10px;
    }

    .tile:hover {
        background-color: rgb(155, 120, 255);
        border-radius: 2px;
    }

    .v-list__tile--active {
        background-color: rgb(155, 120, 255);
        border-radius: 2px;
    }

</style>
